/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Toc_TitleInputs */



/**
* | output |
* | --- |
* | "Contents" |
*
* @param {Help_Toc_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_toc_title = /** @type {((inputs?: Help_Toc_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Toc_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sommaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contenido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sumário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indice")
	return /** @type {LocalizedString} */ ("Contents")
});